import {injectable} from 'inversify';

import type {CategoryModel} from './Category.model';

import {BaseController} from '../Base/Base.controller';

@injectable()
export class CategoryController extends BaseController<CategoryModel> {
  constructor() {
    super();
  }
}
